import { defineMessages } from 'react-intl'

const messages = {
  ok: {
    id: 'app.components.cycle-modal.ok',
    defaultMessage: 'OK',
  },
}

export default defineMessages(messages)
